import './shared/styles/global.scss';
import './setup/polyfill';
import './init';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app';

ReactDOM.render(
  <BrowserRouter basename="/c">
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
import(/* webpackChunkName: "web-vitals" */ '@mrkt/features/web-vitals');

// initialize during development
if (process.env.NODE_ENV === 'development') {
  // todo: always enable in development
  if (localStorage.axeOverlayEnabled === 'true') {
    // eslint-disable-next-line no-console
    console.warn(
      `AxeOverlay is enabled. Set localStorage.axeOverlayEnabled = false to disable.`,
    );

    import(/* webpackChunkName: "axe" */ '@spotify-internal/axe-overlay').then(
      ({ initializeAxeOverlay }) => {
        initializeAxeOverlay(/* axe.RunOptions */);
      },
    );
  } else {
    // eslint-disable-next-line no-console
    console.warn(
      `AxeOverlay is disabled. Set localStorage.axeOverlayEnabled = true to enable.`,
    );
  }
}
